<script>
import { mapState } from 'vuex';
import BiStatsService from '@/services/BiStatsService';

export default {
  name: 'UniqueCallsTable',
  props: {
    filters: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      rawCalls: [],
      totalCompleted: 0,
      headers: [
        { key: 'prisonerNumber', label: 'Prisoner Number' },
        { key: 'completedCalls', label: 'Completed Calls' },
        // { key: 'cancelledCalls', label: 'Cancelled Calls' },
        { key: 'prisonName', label: 'Prison' },
      ],
      limit: 10,
      currentPage: 1,
      totalRows: 0,
      reportLoading: false,
    };
  },
  computed: {
    ...mapState({
      prisons: state => state.stats.prisons,
    }),
    calls() {
      const start = (this.currentPage - 1) * this.limit;
      const end = start + this.limit;

      return this.rawCalls.slice(start, end);
    },
  },
  watch: {
    filters: {
      handler() {
        this.getCalls();
      },
      deep: true,
    },
  },
  mounted() {
    this.setHideCompare(true);
    this.getCalls();
  },
  beforeDestroy() {
    this.setHideCompare(false);
  },
  methods: {
    setHideCompare(hide) {
      this.$store.commit('stats/SET_HIDE_COMPARE', hide);
    },
    async getCalls() {
      this.currentPage = 1;
      this.rawCalls = [];

      const aggregatedData = {};

      const completedResponse = await BiStatsService.getCalls({
        ...this.filters,
        status: 'Completed',
      });

      const completedCalls = [...completedResponse.data];
      this.totalCompleted = completedCalls.length;

      completedCalls.forEach(call => {
        const { name: prisonName } = call.prison;
        const { prisoner_number: prisonerNumber } = call.prisoner;

        if (!aggregatedData[prisonerNumber]) {
          aggregatedData[prisonerNumber] = {
            prisonerNumber,
            prisonName,
            completedCalls: 0,
            cancelledCalls: 0,
          };
        }

        aggregatedData[prisonerNumber].completedCalls += 1;
      });

      // const cancelledResponse = await BiStatsService.getCalls({
      //   status: 'Cancelled',
      //   ...this.filters,
      // });

      // const cancelledCalls = [...cancelledResponse.data];
      // this.totalCancelled = cancelledCalls.length;

      // cancelledCalls.forEach(call => {
      //   const { name: prisonName } = call.prison;
      //   const { prisoner_number: prisonerNumber } = call.prisoner;
      //
      //   if (!aggregatedData[prisonerNumber]) {
      //     aggregatedData[prisonerNumber] = {
      //       prisonerNumber,
      //       prisonName,
      //       completedCalls: 0,
      //       cancelledCalls: 0,
      //     };
      //   }
      //
      //   aggregatedData[prisonerNumber].cancelledCalls += 1;
      // });

      this.rawCalls = Object.values(aggregatedData);
      this.totalRows = this.rawCalls.length;
    },
  },
};
</script>

<template>
  <b-card no-body class="mb-0 p-2">
    <div class="d-flex full-width mb-1 align-items-center">
      <p class="font-weight-bolder mb-0">Unique Calls</p>
      <div class="ui-spacer" />
      <!--      <b-button :class="{'disabled': reportLoading}">-->
      <!--        Download CSV-->
      <!--      </b-button>-->
    </div>

    <p>Total unique users: {{ rawCalls.length }}</p>
    <p>Average calls per user: {{ (rawCalls.length > 0 ? (totalCompleted / rawCalls.length).toFixed(1) : '0') }}</p>

    <b-table
      :current-page="currentPage"
      :fields="headers"
      :items="calls"
      hover
      responsive
    />

    <b-row class="p-1">
      <b-col v-if="totalRows > limit" md="6" class="m-1">
        <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="limit" class="my-0" />
      </b-col>
      <p v-if="totalRows === 0" class="col-6 ml-2 my-1">No Calls available</p>
    </b-row>
  </b-card>
</template>
